import { useEffect, useState } from "react";

import icons from "../constants/icons";
import api from "../functions/api";
import config from "../configs";
import Modal from "../components/modal";
import Page from "../components/page";
import { useParams } from "react-router-dom";

const Download = () => {
  const [download, setDownload] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selItem, setSelectedItem] = useState(null);

  const { id } = useParams();

  const mergedData = (data) => {
    if (!data) return null;
    data = data.reduce((result, item) => {
      const { title, name, link } = item;

      if (title) {
        let group = result.find((g) => g.title === title);
        if (!group) {
          group = { title, links: [] };
          result.push(group);
        }
        group.links.push({ name, link });
      }

      return result;
    }, []);
    return data;
  };

  const getDownloadLinks = async () => {
    try {
      const data = await api.get(`/download-links/${id}`);

      const mergedData = data.reduce((acc, curr) => {
        const existing = acc.find((item) => item.title === curr.title);
        if (existing) {
          existing.links = [...existing.links, ...(curr.links ?? [])];
        } else {
          acc.push({ ...curr });
        }
        return acc;
      }, []);

      setDownload(mergedData);
    } catch (err) {
      console.log("��� ~ getDownloadLinks ~ err:", err);
    }
  };
  useEffect(() => {
    document.querySelector(".page").scrollTo(0, 0);
    id && getDownloadLinks();
  }, [id]);

  return (
    <Page
      title={`Download - ${config.appName}`}
      noIndex
      className="download-page"
    >
      <div className="Download">
        <div className="movieDown">
          <div className="right" style={{ width: "100%" }}>
            <div className="download">
              {download ? (
                !download?.some((i) => {
                  return i?.links?.some((i) => i.title);
                }) ? (
                  download.map((item, index) => (
                    <div key={index} className="downLink">
                      <div className="down">{item?.title}</div>

                      <div className="downBtn">
                        {item?.links?.map((link, linkI) => (
                          <a
                            target="_blank"
                            href={
                              link?.link?.includes("http")
                                ? link?.link
                                : config.apiBaseURL + link?.link
                            }
                            className="btn"
                            key={linkI}
                            rel="nofollow"
                          >
                            <img src={icons.down} />
                            {link?.name}
                          </a>
                        ))}
                      </div>
                    </div>
                  ))
                ) : (
                  download.map((item, index) => (
                    <div key={index} className="downLink">
                      <div className="down">{item?.title}</div>

                      <div
                        className="downBtn"
                        onClick={() => {
                          setSelectedItem(item);
                          setModalOpen(true);
                        }}
                      >
                        <div className="btn">
                          <img src={icons.down} />
                          Download
                        </div>
                      </div>
                    </div>
                  ))
                )
              ) : (
                <div>Loading download links...</div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal show={modalOpen}>
        <div className="modall">
          <div onClick={() => setModalOpen(false)} className="closeIcon">
            <img src={icons.close} />
          </div>

          {mergedData(selItem?.links)?.map((item, index) => {
            return (
              <div className="modalDown" key={index}>
                <div className="down">{item?.title}</div>

                <div className="downBtn">
                  {item?.links?.map((link, linkI) => (
                    <a
                      key={linkI}
                      target="_blank"
                      href={
                        link?.link?.includes("http")
                          ? link?.link
                          : config.apiBaseURL + link?.link
                      }
                      className="btn"
                      rel="nofollow"
                    >
                      <img src={icons.down} />
                      {link?.name}
                    </a>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </Modal>
    </Page>
  );
};

export default Download;
